import { Button, Menu } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import React, { useState } from "react";
import { ChevronDown, Edit, LiveView, Trash } from "tabler-icons-react";

import { useDeleteOrganizationSuperAdmin } from "api/superAdmin/deleteOrganization";
import { useQueryClient } from "@tanstack/react-query";

// import styles from "./ActionsBtn.module.css";
import { useNavigate } from "react-router-dom";

// .not-implemented:hover {
//   cursor: not-allowed;
// }

interface Organization {
  _id?: string;
  id?: string;
  name: string;
}

type ActionsBtnProps = {
  organization?: Organization;
};

function ActionsBtn({ organization }: ActionsBtnProps) {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { mutate: deleteOrg, isLoading: isDeleting } =
    useDeleteOrganizationSuperAdmin();

  const handleDeleteOrganization = () => {
    if (!organization) return;

    const orgId = organization._id || organization.id;
    if (!orgId) {
      showNotification({
        title: "Error",
        message: "Organization ID not found",
        color: "red",
      });
      return;
    }

    const orgName = organization.name || "Organization";
    if (
      window.confirm(
        `Are you sure you want to delete "${orgName}"? This action cannot be undone.`
      )
    ) {
      deleteOrg(orgId, {
        onSuccess: () => {
          // eslint-disable-next-line @typescript-eslint/no-floating-promises
          queryClient.invalidateQueries(["organizations"]);
        },
      });
    }
  };

  if (!organization) {
    return null;
  }

  return (
    <Menu>
      <Menu.Target>
        <Button
          variant="outline"
          rightIcon={<ChevronDown size={16} />}
          pl={10}
          pr={6}
          miw={95}
          size="sm"
          loading={isDeleting}
        >
          Actions
        </Button>
      </Menu.Target>
      <Menu.Dropdown fw={400}>
        <Menu.Item
          icon={<Trash size={18} />}
          color="red.8"
          onClick={handleDeleteOrganization}
          disabled={isDeleting}
        >
          Delete Organization
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}

export default ActionsBtn;
